import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
};

export type AdminUpdateUserInput = {
  avatarUrl?: InputMaybe<Scalars['String']>;
  businessRole?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  status: Status;
};

export type AreaField = {
  __typename?: 'AreaField';
  /** input label displayed to usrs */
  label: Scalars['String'];
  /** internal key for answer value */
  name: Scalars['String'];
  type: Scalars['String'];
};

export type CheckboxField = {
  __typename?: 'CheckboxField';
  /** input label displayed to users */
  label: Scalars['String'];
  /** internal key for answer value */
  name: Scalars['String'];
  type: Scalars['String'];
};

export type CollaboratorInformation = {
  /** Email of the user to invite */
  email: Scalars['String'];
  /** First name of the user to invite */
  firstName: Scalars['String'];
};

export type CreateItemTemplateInput = {
  category: Scalars['ID'];
  highPrice?: InputMaybe<Scalars['Float']>;
  image?: InputMaybe<Scalars['String']>;
  lowPrice?: InputMaybe<Scalars['Float']>;
  midPrice?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
};

export type CreateSpaceTemplateInput = {
  description: Scalars['String'];
  image?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type CreateTaskListTemplateInput = {
  description?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type CreateTaskTemplateInput = {
  /** taskTemplate field data */
  fields?: InputMaybe<Array<TaskFieldInput>>;
  /** name of the taskTemplate */
  name: Scalars['String'];
  /** id of the parent section */
  sectionId: Scalars['ID'];
};

export type CreateUserInput = {
  businessRole?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  securityRoles?: InputMaybe<Array<SecurityRole>>;
  status: Status;
};

export type DateField = {
  __typename?: 'DateField';
  /** input label displayed to users */
  label: Scalars['String'];
  /** internal key for answer value */
  name: Scalars['String'];
  type: Scalars['String'];
};

/** Display User */
export type DisplayUser = {
  __typename?: 'DisplayUser';
  avatarUrl?: Maybe<Scalars['String']>;
  businessRole?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
};

export type DisplayUserSchema = {
  __typename?: 'DisplayUserSchema';
  avatarUrl?: Maybe<Scalars['String']>;
  businessRole?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
};

export type FieldOption = {
  __typename?: 'FieldOption';
  /** input label displayed to user for a single radio input option */
  label: Scalars['String'];
  /** internal value that will be recorded in an answer if this option is selected */
  value: Scalars['String'];
};

export type FieldOptionInput = {
  /** input label displayed to user for a single radio input option */
  label: Scalars['String'];
  /** internal value that will be recorded in an answer if this option is selected */
  value: Scalars['String'];
};

export type Industry = {
  __typename?: 'Industry';
  covers?: Maybe<Array<IndustryCover>>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type IndustryCover = {
  __typename?: 'IndustryCover';
  id: Scalars['ID'];
  url: Scalars['String'];
};

export type ItemCategory = {
  __typename?: 'ItemCategory';
  createdOn: Scalars['DateTime'];
  id: Scalars['ID'];
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addRole: Scalars['Boolean'];
  adminUpdateUser: Scalars['Boolean'];
  createItemTemplate: Scalars['ID'];
  createSpaceTemplate: Scalars['ID'];
  createTaskTemplate: TaskTemplate;
  createTasklistTemplate: Scalars['ID'];
  createUser: Scalars['String'];
  deleteItemTemplate: Scalars['Boolean'];
  deleteSectionTemplate: Scalars['Boolean'];
  deleteSpaceTemplate: Scalars['Boolean'];
  deleteTaskTemplate: Scalars['Boolean'];
  deleteTasklistTemplate: Scalars['Boolean'];
  deleteUser: Scalars['Boolean'];
  inviteCollaboratorsToFolio: Scalars['Boolean'];
  inviteParticipantUser: Scalars['String'];
  inviteTheoremAdmin: Scalars['String'];
  inviteUser: Scalars['String'];
  removeRole: Scalars['Boolean'];
  resendInviteLink: Scalars['Boolean'];
  resendTheoremAdminInviteLink: Scalars['Boolean'];
  updateIsProjectDefault: Scalars['Boolean'];
  updateItemTemplate: Scalars['Boolean'];
  updateSpaceTemplate: Scalars['Boolean'];
  updateTaskTemplate: TaskTemplate;
  updateTasklistTemplate: Scalars['Boolean'];
  updateTenant: Tenant;
  updateUser: Scalars['Boolean'];
  upsertSectionTemplate: SectionTemplate;
};


export type MutationAddRoleArgs = {
  id: Scalars['ID'];
  role: SecurityRole;
};


export type MutationAdminUpdateUserArgs = {
  id: Scalars['ID'];
  userInfo: AdminUpdateUserInput;
};


export type MutationCreateItemTemplateArgs = {
  input: CreateItemTemplateInput;
};


export type MutationCreateSpaceTemplateArgs = {
  input: CreateSpaceTemplateInput;
};


export type MutationCreateTaskTemplateArgs = {
  input: CreateTaskTemplateInput;
};


export type MutationCreateTasklistTemplateArgs = {
  input: CreateTaskListTemplateInput;
};


export type MutationCreateUserArgs = {
  userInfo: CreateUserInput;
};


export type MutationDeleteItemTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSectionTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSpaceTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTaskTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTasklistTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID'];
};


export type MutationInviteCollaboratorsToFolioArgs = {
  collaborators: Array<CollaboratorInformation>;
  tenant?: InputMaybe<TenantDetailsInput>;
};


export type MutationInviteParticipantUserArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  isAdmin?: InputMaybe<Scalars['Boolean']>;
};


export type MutationInviteTheoremAdminArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
};


export type MutationInviteUserArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  securityRoles: Array<SecurityRole>;
};


export type MutationRemoveRoleArgs = {
  id: Scalars['ID'];
  role: SecurityRole;
};


export type MutationResendInviteLinkArgs = {
  email: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationResendTheoremAdminInviteLinkArgs = {
  email: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationUpdateIsProjectDefaultArgs = {
  isDefault: Scalars['Boolean'];
  tasklistTemplateId: Scalars['String'];
};


export type MutationUpdateItemTemplateArgs = {
  input: UpdateItemTemplateInput;
};


export type MutationUpdateSpaceTemplateArgs = {
  input: UpdateSpaceTemplateInput;
};


export type MutationUpdateTaskTemplateArgs = {
  input: UpdateTaskTemplateInput;
};


export type MutationUpdateTasklistTemplateArgs = {
  input: UpdateTasklistTemplateInput;
};


export type MutationUpdateTenantArgs = {
  input: UpdateTenantDetailsInput;
};


export type MutationUpdateUserArgs = {
  userInfo: UpdateUserInput;
};


export type MutationUpsertSectionTemplateArgs = {
  input: UpsertSectionTemplateInput;
};

export type Query = {
  __typename?: 'Query';
  currentUser: User;
  getDisplayUser: DisplayUser;
  getDisplayUsersByUserIds: Array<DisplayUser>;
  getIndustries: Array<Industry>;
  getItemTemplateCategories: Array<ItemCategory>;
  getSpaceItemTemplateById: SpaceItemTemplate;
  getSpaceItemTemplates: Array<SpaceItemTemplate>;
  getSpaceTemplateById: SpaceTemplate;
  getTaskTemplate: TaskTemplate;
  getTaskTemplates: Array<TaskTemplate>;
  getTasklistTemplates: Array<TasklistTemplate>;
  getTenants: Array<Tenant>;
  getTheoremUsers: Array<User>;
  getUser: User;
  getUsers: Array<User>;
  getUsersByUserIds: Array<User>;
  getUsersForProjectInvite: Array<User>;
  listSpaceTemplates: Array<SpaceTemplate>;
  sendParticipantProjectInvite: Scalars['Boolean'];
};


export type QueryGetDisplayUserArgs = {
  id: Scalars['ID'];
};


export type QueryGetDisplayUsersByUserIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetSpaceItemTemplateByIdArgs = {
  templateId: Scalars['ID'];
};


export type QueryGetSpaceTemplateByIdArgs = {
  templateId: Scalars['ID'];
};


export type QueryGetTaskTemplateArgs = {
  id: Scalars['ID'];
};


export type QueryGetUserArgs = {
  id: Scalars['ID'];
};


export type QueryGetUsersByUserIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QuerySendParticipantProjectInviteArgs = {
  projectId: Scalars['String'];
  projectName: Scalars['String'];
  tenant?: InputMaybe<TenantDetailsInput>;
  userId: Scalars['String'];
};

export type RadioField = {
  __typename?: 'RadioField';
  /** internal key for answer value */
  name: Scalars['String'];
  options: Array<FieldOption>;
  type: Scalars['String'];
};

export type SectionTemplate = {
  __typename?: 'SectionTemplate';
  createUser: DisplayUserSchema;
  createdBy: Scalars['ID'];
  createdOn: Scalars['DateTime'];
  /** id of the section */
  id: Scalars['ID'];
  modifiedBy?: Maybe<Scalars['ID']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  modifyUser?: Maybe<DisplayUserSchema>;
  /** name of the section */
  name: Scalars['String'];
  tasklist: TasklistTemplate;
  /** ID of the parent tasklist */
  tasklistId: Scalars['ID'];
  tasks?: Maybe<Array<TaskTemplate>>;
};

export enum SecurityRole {
  Admin = 'Admin',
  Member = 'Member',
  Participant = 'Participant',
  TheoremAdmin = 'TheoremAdmin'
}

export type SpaceItemTemplate = {
  __typename?: 'SpaceItemTemplate';
  category: ItemCategory;
  createdOn: Scalars['DateTime'];
  highPrice: Scalars['Float'];
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  lowPrice: Scalars['Float'];
  midPrice: Scalars['Float'];
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  quantity?: Maybe<Scalars['Int']>;
};

export type SpaceTemplate = {
  __typename?: 'SpaceTemplate';
  createdOn: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  industry?: Maybe<Industry>;
  items?: Maybe<Array<SpaceItemTemplate>>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
};

export type SpaceTemplateItemInput = {
  id: Scalars['ID'];
  quantity: Scalars['Int'];
};

export enum Status {
  Active = 'Active',
  Inactive = 'Inactive',
  Pending = 'Pending'
}

export type TaskField = AreaField | CheckboxField | DateField | RadioField | TextField;

export type TaskFieldInput = {
  /** input label displayed to users */
  label?: InputMaybe<Scalars['String']>;
  /** internal key for answer value */
  name: Scalars['String'];
  options?: InputMaybe<Array<FieldOptionInput>>;
  type: TaskFieldInputDiscriminator;
};

export enum TaskFieldInputDiscriminator {
  Area = 'area',
  Checkbox = 'checkbox',
  Date = 'date',
  Radio = 'radio',
  Text = 'text'
}

export type TaskTemplate = {
  __typename?: 'TaskTemplate';
  createUser: DisplayUserSchema;
  createdBy: Scalars['ID'];
  createdOn: Scalars['DateTime'];
  /** task field data */
  fields: Array<TaskField>;
  /** id of the task */
  id: Scalars['ID'];
  modifiedBy?: Maybe<Scalars['ID']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  modifyUser?: Maybe<DisplayUserSchema>;
  /** name of the task */
  name: Scalars['String'];
  section: SectionTemplate;
  /** ID of the parent section */
  sectionId: Scalars['ID'];
};

export type TasklistTemplate = {
  __typename?: 'TasklistTemplate';
  createUser: DisplayUserSchema;
  createdBy: Scalars['ID'];
  createdOn: Scalars['DateTime'];
  /** description of the tasklist */
  description?: Maybe<Scalars['String']>;
  /** id of the tasklist */
  id: Scalars['ID'];
  /** whether the tasklist is project default */
  isDefault?: Maybe<Scalars['Boolean']>;
  isDefaultChangedOn?: Maybe<Scalars['DateTime']>;
  /** whether the tasklist is visible */
  isVisible: Scalars['Boolean'];
  isVisibleChangedOn?: Maybe<Scalars['DateTime']>;
  modifiedBy?: Maybe<Scalars['ID']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  modifyUser?: Maybe<DisplayUserSchema>;
  /** name of the tasklist */
  name: Scalars['String'];
  sections?: Maybe<Array<SectionTemplate>>;
};

export type Tenant = {
  __typename?: 'Tenant';
  details?: Maybe<TenantsDetails>;
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  subDomain: Scalars['String'];
};

export type TenantDetailsInput = {
  /** Tenant Code */
  code: Scalars['String'];
  /** Tenant Email */
  email?: InputMaybe<Scalars['String']>;
  /** Tenant ID */
  id: Scalars['ID'];
  /** Licenses */
  licenses: Scalars['Int'];
  /** Name */
  tenantName?: InputMaybe<Scalars['String']>;
  /** Used Licenses */
  used?: InputMaybe<Scalars['Int']>;
};

export type TenantsDetails = {
  __typename?: 'TenantsDetails';
  code: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  licenses: Scalars['Int'];
  tenantName?: Maybe<Scalars['String']>;
  used?: Maybe<Scalars['Int']>;
};

export type TextField = {
  __typename?: 'TextField';
  /** input label displayed to users */
  label: Scalars['String'];
  /** internal key for answer value */
  name: Scalars['String'];
  type: Scalars['String'];
};

export type UpdateItemTemplateInput = {
  category: Scalars['ID'];
  highPrice?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  image?: InputMaybe<Scalars['String']>;
  lowPrice?: InputMaybe<Scalars['Float']>;
  midPrice?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
};

export type UpdateSpaceTemplateInput = {
  description: Scalars['String'];
  id: Scalars['ID'];
  image?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['ID']>;
  items: Array<SpaceTemplateItemInput>;
  name: Scalars['String'];
};

export type UpdateTaskTemplateInput = {
  /** taskTemplate field data */
  fields?: InputMaybe<Array<TaskFieldInput>>;
  /** id of the taskTemplate */
  id: Scalars['ID'];
  /** name of the taskTemplate */
  name?: InputMaybe<Scalars['String']>;
  /** id of the parent section */
  sectionId?: InputMaybe<Scalars['ID']>;
};

export type UpdateTasklistTemplateInput = {
  /** description of the tasklist */
  description?: InputMaybe<Scalars['String']>;
  /** id of the tasklist */
  id: Scalars['ID'];
  /** name of the tasklist */
  name: Scalars['String'];
};

export type UpdateTenantDetailsInput = {
  email: Scalars['String'];
  id: Scalars['ID'];
  licenses: Scalars['Int'];
  tenantName: Scalars['String'];
};

export type UpdateUserInput = {
  avatarUrl?: InputMaybe<Scalars['String']>;
  businessRole: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
};

export type UpsertSectionTemplateInput = {
  /** id of the section template - treated like an insert if not supplied */
  id?: InputMaybe<Scalars['ID']>;
  /** name of the section */
  name: Scalars['String'];
  /** ID of the parent tasklist */
  tasklistId: Scalars['ID'];
};

/** users */
export type User = {
  __typename?: 'User';
  avatarUrl?: Maybe<Scalars['String']>;
  businessRole?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isTheoremAdmin?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  securityRoles: Array<SecurityRole>;
  status: Status;
};

export type GetTheoremUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTheoremUsersQuery = { __typename?: 'Query', getTheoremUsers: Array<{ __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, phone?: string | null | undefined, email: string, status: Status, avatarUrl?: string | null | undefined, businessRole?: string | null | undefined, securityRoles: Array<SecurityRole> }> };

export type InviteTheoremAdminMutationVariables = Exact<{
  email: Scalars['String'];
  firstName: Scalars['String'];
}>;


export type InviteTheoremAdminMutation = { __typename?: 'Mutation', inviteTheoremAdmin: string };

export type CreateTaskTemplateMutationVariables = Exact<{
  input: CreateTaskTemplateInput;
}>;


export type CreateTaskTemplateMutation = { __typename?: 'Mutation', createTaskTemplate: { __typename?: 'TaskTemplate', id: string, name: string, sectionId: string, createdOn: any, modifiedOn?: any | null | undefined, createdBy: string, modifiedBy?: string | null | undefined, fields: Array<{ __typename?: 'AreaField' } | { __typename?: 'CheckboxField', name: string, type: string, label: string } | { __typename?: 'DateField', name: string, type: string, label: string } | { __typename?: 'RadioField', name: string, type: string, options: Array<{ __typename?: 'FieldOption', label: string, value: string }> } | { __typename?: 'TextField', name: string, type: string, label: string }> } };

export type DeleteTaskTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTaskTemplateMutation = { __typename?: 'Mutation', deleteTaskTemplate: boolean };

export type DeleteTasklistTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTasklistTemplateMutation = { __typename?: 'Mutation', deleteTasklistTemplate: boolean };

export type GetTaskTemplateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetTaskTemplateQuery = { __typename?: 'Query', getTaskTemplate: { __typename?: 'TaskTemplate', id: string, name: string, sectionId: string, createdOn: any, modifiedOn?: any | null | undefined, createdBy: string, modifiedBy?: string | null | undefined, fields: Array<{ __typename?: 'AreaField' } | { __typename?: 'CheckboxField', name: string, type: string, label: string } | { __typename?: 'DateField', name: string, type: string, label: string } | { __typename?: 'RadioField', name: string, type: string, options: Array<{ __typename?: 'FieldOption', label: string, value: string }> } | { __typename?: 'TextField', name: string, type: string, label: string }> } };

export type GetTaskTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaskTemplatesQuery = { __typename?: 'Query', getTaskTemplates: Array<{ __typename?: 'TaskTemplate', id: string, name: string, sectionId: string, createdOn: any, modifiedOn?: any | null | undefined, createdBy: string, modifiedBy?: string | null | undefined, fields: Array<{ __typename?: 'AreaField' } | { __typename?: 'CheckboxField', name: string, type: string, label: string } | { __typename?: 'DateField', name: string, type: string, label: string } | { __typename?: 'RadioField', name: string, type: string, options: Array<{ __typename?: 'FieldOption', label: string, value: string }> } | { __typename?: 'TextField', name: string, type: string, label: string }> }> };

export type GetTasklistTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTasklistTemplatesQuery = { __typename?: 'Query', getTasklistTemplates: Array<{ __typename?: 'TasklistTemplate', id: string, name: string, description?: string | null | undefined, createdOn: any, modifiedOn?: any | null | undefined, createUser: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined }, modifyUser?: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined, sections?: Array<{ __typename?: 'SectionTemplate', id: string, name: string, createdOn: any, modifiedOn?: any | null | undefined, createUser: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined }, modifyUser?: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined, tasks?: Array<{ __typename?: 'TaskTemplate', id: string, name: string, sectionId: string, createUser: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined }, modifyUser?: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined, fields: Array<{ __typename?: 'AreaField' } | { __typename?: 'CheckboxField', name: string, type: string, label: string } | { __typename?: 'DateField', name: string, type: string, label: string } | { __typename?: 'RadioField', name: string, type: string, options: Array<{ __typename?: 'FieldOption', label: string, value: string }> } | { __typename?: 'TextField', name: string, type: string, label: string }> }> | null | undefined }> | null | undefined }> };

export type UpdateIsProjectDefaultMutationVariables = Exact<{
  tasklistTemplateId: Scalars['String'];
  isDefault: Scalars['Boolean'];
}>;


export type UpdateIsProjectDefaultMutation = { __typename?: 'Mutation', updateIsProjectDefault: boolean };

export type UpdateTaskTemplateMutationVariables = Exact<{
  input: UpdateTaskTemplateInput;
}>;


export type UpdateTaskTemplateMutation = { __typename?: 'Mutation', updateTaskTemplate: { __typename?: 'TaskTemplate', id: string, name: string, sectionId: string, createdOn: any, modifiedOn?: any | null | undefined, createdBy: string, modifiedBy?: string | null | undefined, fields: Array<{ __typename?: 'AreaField', name: string, type: string, label: string } | { __typename?: 'CheckboxField', name: string, type: string, label: string } | { __typename?: 'DateField', name: string, type: string, label: string } | { __typename?: 'RadioField', name: string, type: string, options: Array<{ __typename?: 'FieldOption', label: string, value: string }> } | { __typename?: 'TextField', name: string, type: string, label: string }> } };

export type UpdateTasklistTemplateMutationVariables = Exact<{
  input: UpdateTasklistTemplateInput;
}>;


export type UpdateTasklistTemplateMutation = { __typename?: 'Mutation', updateTasklistTemplate: boolean };

export type UpsertSectionTemplateMutationVariables = Exact<{
  input: UpsertSectionTemplateInput;
}>;


export type UpsertSectionTemplateMutation = { __typename?: 'Mutation', upsertSectionTemplate: { __typename?: 'SectionTemplate', id: string, name: string, tasklistId: string, createUser: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined }, modifyUser?: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined } };

export type AddRoleMutationVariables = Exact<{
  id: Scalars['ID'];
  role: SecurityRole;
}>;


export type AddRoleMutation = { __typename?: 'Mutation', addRole: boolean };

export type AdminUpdateUserMutationVariables = Exact<{
  id: Scalars['ID'];
  userInfo: AdminUpdateUserInput;
}>;


export type AdminUpdateUserMutation = { __typename?: 'Mutation', adminUpdateUser: boolean };

export type GetDisplayUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDisplayUserQuery = { __typename?: 'Query', getDisplayUser: { __typename?: 'DisplayUser', firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined, businessRole?: string | null | undefined } };

export type GetDisplayUsersByUserIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetDisplayUsersByUserIdsQuery = { __typename?: 'Query', getDisplayUsersByUserIds: Array<{ __typename?: 'DisplayUser', firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined, businessRole?: string | null | undefined }> };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { __typename?: 'Query', getUsers: Array<{ __typename?: 'User', avatarUrl?: string | null | undefined, id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, phone?: string | null | undefined, email: string, status: Status, businessRole?: string | null | undefined, securityRoles: Array<SecurityRole> }> };

export type GetUsersByUserIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetUsersByUserIdsQuery = { __typename?: 'Query', getUsersByUserIds: Array<{ __typename?: 'User', id: string, email: string, status: Status, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined, phone?: string | null | undefined, businessRole?: string | null | undefined, securityRoles: Array<SecurityRole> }> };

export type InviteUserMutationVariables = Exact<{
  email: Scalars['String'];
  firstName: Scalars['String'];
  securityRoles: Array<SecurityRole> | SecurityRole;
}>;


export type InviteUserMutation = { __typename?: 'Mutation', inviteUser: string };

export type LoadCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, avatarUrl?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, phone?: string | null | undefined, email: string, status: Status, businessRole?: string | null | undefined, securityRoles: Array<SecurityRole>, isTheoremAdmin?: boolean | null | undefined } };

export type RemoveRoleMutationVariables = Exact<{
  id: Scalars['ID'];
  role: SecurityRole;
}>;


export type RemoveRoleMutation = { __typename?: 'Mutation', removeRole: boolean };

export type ResendInviteLinkMutationVariables = Exact<{
  email: Scalars['String'];
  id: Scalars['ID'];
}>;


export type ResendInviteLinkMutation = { __typename?: 'Mutation', resendInviteLink: boolean };

export type ResendTheoremAdminInviteLinkMutationVariables = Exact<{
  email: Scalars['String'];
  id: Scalars['ID'];
}>;


export type ResendTheoremAdminInviteLinkMutation = { __typename?: 'Mutation', resendTheoremAdminInviteLink: boolean };

export type UpdateUserMutationVariables = Exact<{
  userInfo: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: boolean };

export type AreaFieldKeySpecifier = ('label' | 'name' | 'type' | AreaFieldKeySpecifier)[];
export type AreaFieldFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckboxFieldKeySpecifier = ('label' | 'name' | 'type' | CheckboxFieldKeySpecifier)[];
export type CheckboxFieldFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DateFieldKeySpecifier = ('label' | 'name' | 'type' | DateFieldKeySpecifier)[];
export type DateFieldFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisplayUserKeySpecifier = ('avatarUrl' | 'businessRole' | 'firstName' | 'id' | 'lastName' | DisplayUserKeySpecifier)[];
export type DisplayUserFieldPolicy = {
	avatarUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	businessRole?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisplayUserSchemaKeySpecifier = ('avatarUrl' | 'businessRole' | 'firstName' | 'id' | 'lastName' | DisplayUserSchemaKeySpecifier)[];
export type DisplayUserSchemaFieldPolicy = {
	avatarUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	businessRole?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FieldOptionKeySpecifier = ('label' | 'value' | FieldOptionKeySpecifier)[];
export type FieldOptionFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IndustryKeySpecifier = ('covers' | 'id' | 'name' | IndustryKeySpecifier)[];
export type IndustryFieldPolicy = {
	covers?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IndustryCoverKeySpecifier = ('id' | 'url' | IndustryCoverKeySpecifier)[];
export type IndustryCoverFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemCategoryKeySpecifier = ('createdOn' | 'id' | 'modifiedOn' | 'name' | ItemCategoryKeySpecifier)[];
export type ItemCategoryFieldPolicy = {
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('addRole' | 'adminUpdateUser' | 'createItemTemplate' | 'createSpaceTemplate' | 'createTaskTemplate' | 'createTasklistTemplate' | 'createUser' | 'deleteItemTemplate' | 'deleteSectionTemplate' | 'deleteSpaceTemplate' | 'deleteTaskTemplate' | 'deleteTasklistTemplate' | 'deleteUser' | 'inviteCollaboratorsToFolio' | 'inviteParticipantUser' | 'inviteTheoremAdmin' | 'inviteUser' | 'removeRole' | 'resendInviteLink' | 'resendTheoremAdminInviteLink' | 'updateIsProjectDefault' | 'updateItemTemplate' | 'updateSpaceTemplate' | 'updateTaskTemplate' | 'updateTasklistTemplate' | 'updateTenant' | 'updateUser' | 'upsertSectionTemplate' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	addRole?: FieldPolicy<any> | FieldReadFunction<any>,
	adminUpdateUser?: FieldPolicy<any> | FieldReadFunction<any>,
	createItemTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	createSpaceTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	createTaskTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	createTasklistTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	createUser?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteItemTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteSectionTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteSpaceTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteTaskTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteTasklistTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteUser?: FieldPolicy<any> | FieldReadFunction<any>,
	inviteCollaboratorsToFolio?: FieldPolicy<any> | FieldReadFunction<any>,
	inviteParticipantUser?: FieldPolicy<any> | FieldReadFunction<any>,
	inviteTheoremAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	inviteUser?: FieldPolicy<any> | FieldReadFunction<any>,
	removeRole?: FieldPolicy<any> | FieldReadFunction<any>,
	resendInviteLink?: FieldPolicy<any> | FieldReadFunction<any>,
	resendTheoremAdminInviteLink?: FieldPolicy<any> | FieldReadFunction<any>,
	updateIsProjectDefault?: FieldPolicy<any> | FieldReadFunction<any>,
	updateItemTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSpaceTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTaskTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTasklistTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTenant?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUser?: FieldPolicy<any> | FieldReadFunction<any>,
	upsertSectionTemplate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('currentUser' | 'getDisplayUser' | 'getDisplayUsersByUserIds' | 'getIndustries' | 'getItemTemplateCategories' | 'getSpaceItemTemplateById' | 'getSpaceItemTemplates' | 'getSpaceTemplateById' | 'getTaskTemplate' | 'getTaskTemplates' | 'getTasklistTemplates' | 'getTenants' | 'getTheoremUsers' | 'getUser' | 'getUsers' | 'getUsersByUserIds' | 'getUsersForProjectInvite' | 'listSpaceTemplates' | 'sendParticipantProjectInvite' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	currentUser?: FieldPolicy<any> | FieldReadFunction<any>,
	getDisplayUser?: FieldPolicy<any> | FieldReadFunction<any>,
	getDisplayUsersByUserIds?: FieldPolicy<any> | FieldReadFunction<any>,
	getIndustries?: FieldPolicy<any> | FieldReadFunction<any>,
	getItemTemplateCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	getSpaceItemTemplateById?: FieldPolicy<any> | FieldReadFunction<any>,
	getSpaceItemTemplates?: FieldPolicy<any> | FieldReadFunction<any>,
	getSpaceTemplateById?: FieldPolicy<any> | FieldReadFunction<any>,
	getTaskTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	getTaskTemplates?: FieldPolicy<any> | FieldReadFunction<any>,
	getTasklistTemplates?: FieldPolicy<any> | FieldReadFunction<any>,
	getTenants?: FieldPolicy<any> | FieldReadFunction<any>,
	getTheoremUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	getUser?: FieldPolicy<any> | FieldReadFunction<any>,
	getUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	getUsersByUserIds?: FieldPolicy<any> | FieldReadFunction<any>,
	getUsersForProjectInvite?: FieldPolicy<any> | FieldReadFunction<any>,
	listSpaceTemplates?: FieldPolicy<any> | FieldReadFunction<any>,
	sendParticipantProjectInvite?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RadioFieldKeySpecifier = ('name' | 'options' | 'type' | RadioFieldKeySpecifier)[];
export type RadioFieldFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SectionTemplateKeySpecifier = ('createUser' | 'createdBy' | 'createdOn' | 'id' | 'modifiedBy' | 'modifiedOn' | 'modifyUser' | 'name' | 'tasklist' | 'tasklistId' | 'tasks' | SectionTemplateKeySpecifier)[];
export type SectionTemplateFieldPolicy = {
	createUser?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	modifyUser?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	tasklist?: FieldPolicy<any> | FieldReadFunction<any>,
	tasklistId?: FieldPolicy<any> | FieldReadFunction<any>,
	tasks?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SpaceItemTemplateKeySpecifier = ('category' | 'createdOn' | 'highPrice' | 'id' | 'image' | 'lowPrice' | 'midPrice' | 'modifiedOn' | 'name' | 'quantity' | SpaceItemTemplateKeySpecifier)[];
export type SpaceItemTemplateFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	highPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	lowPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	midPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SpaceTemplateKeySpecifier = ('createdOn' | 'description' | 'id' | 'image' | 'industry' | 'items' | 'modifiedOn' | 'name' | SpaceTemplateKeySpecifier)[];
export type SpaceTemplateFieldPolicy = {
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	industry?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskTemplateKeySpecifier = ('createUser' | 'createdBy' | 'createdOn' | 'fields' | 'id' | 'modifiedBy' | 'modifiedOn' | 'modifyUser' | 'name' | 'section' | 'sectionId' | TaskTemplateKeySpecifier)[];
export type TaskTemplateFieldPolicy = {
	createUser?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	modifyUser?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	section?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TasklistTemplateKeySpecifier = ('createUser' | 'createdBy' | 'createdOn' | 'description' | 'id' | 'isDefault' | 'isDefaultChangedOn' | 'isVisible' | 'isVisibleChangedOn' | 'modifiedBy' | 'modifiedOn' | 'modifyUser' | 'name' | 'sections' | TasklistTemplateKeySpecifier)[];
export type TasklistTemplateFieldPolicy = {
	createUser?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isDefault?: FieldPolicy<any> | FieldReadFunction<any>,
	isDefaultChangedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	isVisible?: FieldPolicy<any> | FieldReadFunction<any>,
	isVisibleChangedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	modifyUser?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	sections?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantKeySpecifier = ('details' | 'name' | 'ownerId' | 'subDomain' | TenantKeySpecifier)[];
export type TenantFieldPolicy = {
	details?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerId?: FieldPolicy<any> | FieldReadFunction<any>,
	subDomain?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantsDetailsKeySpecifier = ('code' | 'email' | 'id' | 'licenses' | 'tenantName' | 'used' | TenantsDetailsKeySpecifier)[];
export type TenantsDetailsFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	licenses?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantName?: FieldPolicy<any> | FieldReadFunction<any>,
	used?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TextFieldKeySpecifier = ('label' | 'name' | 'type' | TextFieldKeySpecifier)[];
export type TextFieldFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserKeySpecifier = ('avatarUrl' | 'businessRole' | 'email' | 'firstName' | 'id' | 'isTheoremAdmin' | 'lastName' | 'phone' | 'securityRoles' | 'status' | UserKeySpecifier)[];
export type UserFieldPolicy = {
	avatarUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	businessRole?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isTheoremAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	securityRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	AreaField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AreaFieldKeySpecifier | (() => undefined | AreaFieldKeySpecifier),
		fields?: AreaFieldFieldPolicy,
	},
	CheckboxField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckboxFieldKeySpecifier | (() => undefined | CheckboxFieldKeySpecifier),
		fields?: CheckboxFieldFieldPolicy,
	},
	DateField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DateFieldKeySpecifier | (() => undefined | DateFieldKeySpecifier),
		fields?: DateFieldFieldPolicy,
	},
	DisplayUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisplayUserKeySpecifier | (() => undefined | DisplayUserKeySpecifier),
		fields?: DisplayUserFieldPolicy,
	},
	DisplayUserSchema?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisplayUserSchemaKeySpecifier | (() => undefined | DisplayUserSchemaKeySpecifier),
		fields?: DisplayUserSchemaFieldPolicy,
	},
	FieldOption?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FieldOptionKeySpecifier | (() => undefined | FieldOptionKeySpecifier),
		fields?: FieldOptionFieldPolicy,
	},
	Industry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IndustryKeySpecifier | (() => undefined | IndustryKeySpecifier),
		fields?: IndustryFieldPolicy,
	},
	IndustryCover?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IndustryCoverKeySpecifier | (() => undefined | IndustryCoverKeySpecifier),
		fields?: IndustryCoverFieldPolicy,
	},
	ItemCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemCategoryKeySpecifier | (() => undefined | ItemCategoryKeySpecifier),
		fields?: ItemCategoryFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	RadioField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RadioFieldKeySpecifier | (() => undefined | RadioFieldKeySpecifier),
		fields?: RadioFieldFieldPolicy,
	},
	SectionTemplate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SectionTemplateKeySpecifier | (() => undefined | SectionTemplateKeySpecifier),
		fields?: SectionTemplateFieldPolicy,
	},
	SpaceItemTemplate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SpaceItemTemplateKeySpecifier | (() => undefined | SpaceItemTemplateKeySpecifier),
		fields?: SpaceItemTemplateFieldPolicy,
	},
	SpaceTemplate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SpaceTemplateKeySpecifier | (() => undefined | SpaceTemplateKeySpecifier),
		fields?: SpaceTemplateFieldPolicy,
	},
	TaskTemplate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskTemplateKeySpecifier | (() => undefined | TaskTemplateKeySpecifier),
		fields?: TaskTemplateFieldPolicy,
	},
	TasklistTemplate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TasklistTemplateKeySpecifier | (() => undefined | TasklistTemplateKeySpecifier),
		fields?: TasklistTemplateFieldPolicy,
	},
	Tenant?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantKeySpecifier | (() => undefined | TenantKeySpecifier),
		fields?: TenantFieldPolicy,
	},
	TenantsDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantsDetailsKeySpecifier | (() => undefined | TenantsDetailsKeySpecifier),
		fields?: TenantsDetailsFieldPolicy,
	},
	TextField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TextFieldKeySpecifier | (() => undefined | TextFieldKeySpecifier),
		fields?: TextFieldFieldPolicy,
	},
	User?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserKeySpecifier | (() => undefined | UserKeySpecifier),
		fields?: UserFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;

export const GetTheoremUsersDocument = gql`
    query GetTheoremUsers {
  getTheoremUsers {
    id
    firstName
    lastName
    phone
    email
    status
    avatarUrl
    businessRole
    securityRoles
  }
}
    `;

/**
 * __useGetTheoremUsersQuery__
 *
 * To run a query within a React component, call `useGetTheoremUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTheoremUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTheoremUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTheoremUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetTheoremUsersQuery, GetTheoremUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTheoremUsersQuery, GetTheoremUsersQueryVariables>(GetTheoremUsersDocument, options);
      }
export function useGetTheoremUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTheoremUsersQuery, GetTheoremUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTheoremUsersQuery, GetTheoremUsersQueryVariables>(GetTheoremUsersDocument, options);
        }
export type GetTheoremUsersQueryHookResult = ReturnType<typeof useGetTheoremUsersQuery>;
export type GetTheoremUsersLazyQueryHookResult = ReturnType<typeof useGetTheoremUsersLazyQuery>;
export type GetTheoremUsersQueryResult = Apollo.QueryResult<GetTheoremUsersQuery, GetTheoremUsersQueryVariables>;
export const InviteTheoremAdminDocument = gql`
    mutation InviteTheoremAdmin($email: String!, $firstName: String!) {
  inviteTheoremAdmin(email: $email, firstName: $firstName)
}
    `;
export type InviteTheoremAdminMutationFn = Apollo.MutationFunction<InviteTheoremAdminMutation, InviteTheoremAdminMutationVariables>;

/**
 * __useInviteTheoremAdminMutation__
 *
 * To run a mutation, you first call `useInviteTheoremAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteTheoremAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteTheoremAdminMutation, { data, loading, error }] = useInviteTheoremAdminMutation({
 *   variables: {
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *   },
 * });
 */
export function useInviteTheoremAdminMutation(baseOptions?: Apollo.MutationHookOptions<InviteTheoremAdminMutation, InviteTheoremAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteTheoremAdminMutation, InviteTheoremAdminMutationVariables>(InviteTheoremAdminDocument, options);
      }
export type InviteTheoremAdminMutationHookResult = ReturnType<typeof useInviteTheoremAdminMutation>;
export type InviteTheoremAdminMutationResult = Apollo.MutationResult<InviteTheoremAdminMutation>;
export type InviteTheoremAdminMutationOptions = Apollo.BaseMutationOptions<InviteTheoremAdminMutation, InviteTheoremAdminMutationVariables>;
export const CreateTaskTemplateDocument = gql`
    mutation CreateTaskTemplate($input: CreateTaskTemplateInput!) {
  createTaskTemplate(input: $input) {
    id
    name
    sectionId
    createdOn
    modifiedOn
    createdBy
    modifiedBy
    fields {
      ... on RadioField {
        name
        type
        options {
          label
          value
        }
      }
      ... on TextField {
        name
        type
        label
      }
      ... on CheckboxField {
        name
        type
        label
      }
      ... on DateField {
        name
        type
        label
      }
    }
  }
}
    `;
export type CreateTaskTemplateMutationFn = Apollo.MutationFunction<CreateTaskTemplateMutation, CreateTaskTemplateMutationVariables>;

/**
 * __useCreateTaskTemplateMutation__
 *
 * To run a mutation, you first call `useCreateTaskTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskTemplateMutation, { data, loading, error }] = useCreateTaskTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskTemplateMutation, CreateTaskTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskTemplateMutation, CreateTaskTemplateMutationVariables>(CreateTaskTemplateDocument, options);
      }
export type CreateTaskTemplateMutationHookResult = ReturnType<typeof useCreateTaskTemplateMutation>;
export type CreateTaskTemplateMutationResult = Apollo.MutationResult<CreateTaskTemplateMutation>;
export type CreateTaskTemplateMutationOptions = Apollo.BaseMutationOptions<CreateTaskTemplateMutation, CreateTaskTemplateMutationVariables>;
export const DeleteTaskTemplateDocument = gql`
    mutation DeleteTaskTemplate($id: ID!) {
  deleteTaskTemplate(id: $id)
}
    `;
export type DeleteTaskTemplateMutationFn = Apollo.MutationFunction<DeleteTaskTemplateMutation, DeleteTaskTemplateMutationVariables>;

/**
 * __useDeleteTaskTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteTaskTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskTemplateMutation, { data, loading, error }] = useDeleteTaskTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTaskTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaskTemplateMutation, DeleteTaskTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaskTemplateMutation, DeleteTaskTemplateMutationVariables>(DeleteTaskTemplateDocument, options);
      }
export type DeleteTaskTemplateMutationHookResult = ReturnType<typeof useDeleteTaskTemplateMutation>;
export type DeleteTaskTemplateMutationResult = Apollo.MutationResult<DeleteTaskTemplateMutation>;
export type DeleteTaskTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteTaskTemplateMutation, DeleteTaskTemplateMutationVariables>;
export const DeleteTasklistTemplateDocument = gql`
    mutation DeleteTasklistTemplate($id: ID!) {
  deleteTasklistTemplate(id: $id)
}
    `;
export type DeleteTasklistTemplateMutationFn = Apollo.MutationFunction<DeleteTasklistTemplateMutation, DeleteTasklistTemplateMutationVariables>;

/**
 * __useDeleteTasklistTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteTasklistTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTasklistTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTasklistTemplateMutation, { data, loading, error }] = useDeleteTasklistTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTasklistTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTasklistTemplateMutation, DeleteTasklistTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTasklistTemplateMutation, DeleteTasklistTemplateMutationVariables>(DeleteTasklistTemplateDocument, options);
      }
export type DeleteTasklistTemplateMutationHookResult = ReturnType<typeof useDeleteTasklistTemplateMutation>;
export type DeleteTasklistTemplateMutationResult = Apollo.MutationResult<DeleteTasklistTemplateMutation>;
export type DeleteTasklistTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteTasklistTemplateMutation, DeleteTasklistTemplateMutationVariables>;
export const GetTaskTemplateDocument = gql`
    query GetTaskTemplate($id: ID!) {
  getTaskTemplate(id: $id) {
    id
    name
    sectionId
    createdOn
    modifiedOn
    createdBy
    modifiedBy
    fields {
      ... on RadioField {
        name
        type
        options {
          label
          value
        }
      }
      ... on TextField {
        name
        type
        label
      }
      ... on CheckboxField {
        name
        type
        label
      }
      ... on DateField {
        name
        type
        label
      }
    }
  }
}
    `;

/**
 * __useGetTaskTemplateQuery__
 *
 * To run a query within a React component, call `useGetTaskTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetTaskTemplateQuery, GetTaskTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskTemplateQuery, GetTaskTemplateQueryVariables>(GetTaskTemplateDocument, options);
      }
export function useGetTaskTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskTemplateQuery, GetTaskTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskTemplateQuery, GetTaskTemplateQueryVariables>(GetTaskTemplateDocument, options);
        }
export type GetTaskTemplateQueryHookResult = ReturnType<typeof useGetTaskTemplateQuery>;
export type GetTaskTemplateLazyQueryHookResult = ReturnType<typeof useGetTaskTemplateLazyQuery>;
export type GetTaskTemplateQueryResult = Apollo.QueryResult<GetTaskTemplateQuery, GetTaskTemplateQueryVariables>;
export const GetTaskTemplatesDocument = gql`
    query GetTaskTemplates {
  getTaskTemplates {
    id
    name
    sectionId
    createdOn
    modifiedOn
    createdBy
    modifiedBy
    fields {
      ... on RadioField {
        name
        type
        options {
          label
          value
        }
      }
      ... on TextField {
        name
        type
        label
      }
      ... on CheckboxField {
        name
        type
        label
      }
      ... on DateField {
        name
        type
        label
      }
    }
  }
}
    `;

/**
 * __useGetTaskTemplatesQuery__
 *
 * To run a query within a React component, call `useGetTaskTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaskTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetTaskTemplatesQuery, GetTaskTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskTemplatesQuery, GetTaskTemplatesQueryVariables>(GetTaskTemplatesDocument, options);
      }
export function useGetTaskTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskTemplatesQuery, GetTaskTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskTemplatesQuery, GetTaskTemplatesQueryVariables>(GetTaskTemplatesDocument, options);
        }
export type GetTaskTemplatesQueryHookResult = ReturnType<typeof useGetTaskTemplatesQuery>;
export type GetTaskTemplatesLazyQueryHookResult = ReturnType<typeof useGetTaskTemplatesLazyQuery>;
export type GetTaskTemplatesQueryResult = Apollo.QueryResult<GetTaskTemplatesQuery, GetTaskTemplatesQueryVariables>;
export const GetTasklistTemplatesDocument = gql`
    query GetTasklistTemplates {
  getTasklistTemplates {
    id
    name
    description
    createdOn
    modifiedOn
    createUser {
      id
      firstName
      lastName
      avatarUrl
    }
    modifyUser {
      id
      firstName
      lastName
      avatarUrl
    }
    sections {
      id
      name
      createdOn
      modifiedOn
      createUser {
        id
        firstName
        lastName
        avatarUrl
      }
      modifyUser {
        id
        firstName
        lastName
        avatarUrl
      }
      tasks {
        id
        name
        sectionId
        createUser {
          id
          firstName
          lastName
          avatarUrl
        }
        modifyUser {
          id
          firstName
          lastName
          avatarUrl
        }
        fields {
          ... on RadioField {
            name
            type
            options {
              label
              value
            }
          }
          ... on TextField {
            name
            type
            label
          }
          ... on CheckboxField {
            name
            type
            label
          }
          ... on DateField {
            name
            type
            label
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetTasklistTemplatesQuery__
 *
 * To run a query within a React component, call `useGetTasklistTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasklistTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasklistTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTasklistTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetTasklistTemplatesQuery, GetTasklistTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTasklistTemplatesQuery, GetTasklistTemplatesQueryVariables>(GetTasklistTemplatesDocument, options);
      }
export function useGetTasklistTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTasklistTemplatesQuery, GetTasklistTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTasklistTemplatesQuery, GetTasklistTemplatesQueryVariables>(GetTasklistTemplatesDocument, options);
        }
export type GetTasklistTemplatesQueryHookResult = ReturnType<typeof useGetTasklistTemplatesQuery>;
export type GetTasklistTemplatesLazyQueryHookResult = ReturnType<typeof useGetTasklistTemplatesLazyQuery>;
export type GetTasklistTemplatesQueryResult = Apollo.QueryResult<GetTasklistTemplatesQuery, GetTasklistTemplatesQueryVariables>;
export const UpdateIsProjectDefaultDocument = gql`
    mutation UpdateIsProjectDefault($tasklistTemplateId: String!, $isDefault: Boolean!) {
  updateIsProjectDefault(
    tasklistTemplateId: $tasklistTemplateId
    isDefault: $isDefault
  )
}
    `;
export type UpdateIsProjectDefaultMutationFn = Apollo.MutationFunction<UpdateIsProjectDefaultMutation, UpdateIsProjectDefaultMutationVariables>;

/**
 * __useUpdateIsProjectDefaultMutation__
 *
 * To run a mutation, you first call `useUpdateIsProjectDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIsProjectDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIsProjectDefaultMutation, { data, loading, error }] = useUpdateIsProjectDefaultMutation({
 *   variables: {
 *      tasklistTemplateId: // value for 'tasklistTemplateId'
 *      isDefault: // value for 'isDefault'
 *   },
 * });
 */
export function useUpdateIsProjectDefaultMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIsProjectDefaultMutation, UpdateIsProjectDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIsProjectDefaultMutation, UpdateIsProjectDefaultMutationVariables>(UpdateIsProjectDefaultDocument, options);
      }
export type UpdateIsProjectDefaultMutationHookResult = ReturnType<typeof useUpdateIsProjectDefaultMutation>;
export type UpdateIsProjectDefaultMutationResult = Apollo.MutationResult<UpdateIsProjectDefaultMutation>;
export type UpdateIsProjectDefaultMutationOptions = Apollo.BaseMutationOptions<UpdateIsProjectDefaultMutation, UpdateIsProjectDefaultMutationVariables>;
export const UpdateTaskTemplateDocument = gql`
    mutation UpdateTaskTemplate($input: UpdateTaskTemplateInput!) {
  updateTaskTemplate(input: $input) {
    id
    name
    sectionId
    createdOn
    modifiedOn
    createdBy
    modifiedBy
    fields {
      ... on RadioField {
        name
        type
        options {
          label
          value
        }
      }
      ... on AreaField {
        name
        type
        label
      }
      ... on TextField {
        name
        type
        label
      }
      ... on CheckboxField {
        name
        type
        label
      }
      ... on DateField {
        name
        type
        label
      }
    }
  }
}
    `;
export type UpdateTaskTemplateMutationFn = Apollo.MutationFunction<UpdateTaskTemplateMutation, UpdateTaskTemplateMutationVariables>;

/**
 * __useUpdateTaskTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateTaskTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskTemplateMutation, { data, loading, error }] = useUpdateTaskTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskTemplateMutation, UpdateTaskTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskTemplateMutation, UpdateTaskTemplateMutationVariables>(UpdateTaskTemplateDocument, options);
      }
export type UpdateTaskTemplateMutationHookResult = ReturnType<typeof useUpdateTaskTemplateMutation>;
export type UpdateTaskTemplateMutationResult = Apollo.MutationResult<UpdateTaskTemplateMutation>;
export type UpdateTaskTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateTaskTemplateMutation, UpdateTaskTemplateMutationVariables>;
export const UpdateTasklistTemplateDocument = gql`
    mutation UpdateTasklistTemplate($input: UpdateTasklistTemplateInput!) {
  updateTasklistTemplate(input: $input)
}
    `;
export type UpdateTasklistTemplateMutationFn = Apollo.MutationFunction<UpdateTasklistTemplateMutation, UpdateTasklistTemplateMutationVariables>;

/**
 * __useUpdateTasklistTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateTasklistTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTasklistTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTasklistTemplateMutation, { data, loading, error }] = useUpdateTasklistTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTasklistTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTasklistTemplateMutation, UpdateTasklistTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTasklistTemplateMutation, UpdateTasklistTemplateMutationVariables>(UpdateTasklistTemplateDocument, options);
      }
export type UpdateTasklistTemplateMutationHookResult = ReturnType<typeof useUpdateTasklistTemplateMutation>;
export type UpdateTasklistTemplateMutationResult = Apollo.MutationResult<UpdateTasklistTemplateMutation>;
export type UpdateTasklistTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateTasklistTemplateMutation, UpdateTasklistTemplateMutationVariables>;
export const UpsertSectionTemplateDocument = gql`
    mutation UpsertSectionTemplate($input: UpsertSectionTemplateInput!) {
  upsertSectionTemplate(input: $input) {
    id
    name
    tasklistId
    createUser {
      id
      firstName
      lastName
      avatarUrl
    }
    modifyUser {
      id
      firstName
      lastName
      avatarUrl
    }
  }
}
    `;
export type UpsertSectionTemplateMutationFn = Apollo.MutationFunction<UpsertSectionTemplateMutation, UpsertSectionTemplateMutationVariables>;

/**
 * __useUpsertSectionTemplateMutation__
 *
 * To run a mutation, you first call `useUpsertSectionTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSectionTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSectionTemplateMutation, { data, loading, error }] = useUpsertSectionTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertSectionTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSectionTemplateMutation, UpsertSectionTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSectionTemplateMutation, UpsertSectionTemplateMutationVariables>(UpsertSectionTemplateDocument, options);
      }
export type UpsertSectionTemplateMutationHookResult = ReturnType<typeof useUpsertSectionTemplateMutation>;
export type UpsertSectionTemplateMutationResult = Apollo.MutationResult<UpsertSectionTemplateMutation>;
export type UpsertSectionTemplateMutationOptions = Apollo.BaseMutationOptions<UpsertSectionTemplateMutation, UpsertSectionTemplateMutationVariables>;
export const AddRoleDocument = gql`
    mutation AddRole($id: ID!, $role: SecurityRole!) {
  addRole(id: $id, role: $role)
}
    `;
export type AddRoleMutationFn = Apollo.MutationFunction<AddRoleMutation, AddRoleMutationVariables>;

/**
 * __useAddRoleMutation__
 *
 * To run a mutation, you first call `useAddRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRoleMutation, { data, loading, error }] = useAddRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useAddRoleMutation(baseOptions?: Apollo.MutationHookOptions<AddRoleMutation, AddRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRoleMutation, AddRoleMutationVariables>(AddRoleDocument, options);
      }
export type AddRoleMutationHookResult = ReturnType<typeof useAddRoleMutation>;
export type AddRoleMutationResult = Apollo.MutationResult<AddRoleMutation>;
export type AddRoleMutationOptions = Apollo.BaseMutationOptions<AddRoleMutation, AddRoleMutationVariables>;
export const AdminUpdateUserDocument = gql`
    mutation AdminUpdateUser($id: ID!, $userInfo: AdminUpdateUserInput!) {
  adminUpdateUser(id: $id, userInfo: $userInfo)
}
    `;
export type AdminUpdateUserMutationFn = Apollo.MutationFunction<AdminUpdateUserMutation, AdminUpdateUserMutationVariables>;

/**
 * __useAdminUpdateUserMutation__
 *
 * To run a mutation, you first call `useAdminUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateUserMutation, { data, loading, error }] = useAdminUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userInfo: // value for 'userInfo'
 *   },
 * });
 */
export function useAdminUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateUserMutation, AdminUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateUserMutation, AdminUpdateUserMutationVariables>(AdminUpdateUserDocument, options);
      }
export type AdminUpdateUserMutationHookResult = ReturnType<typeof useAdminUpdateUserMutation>;
export type AdminUpdateUserMutationResult = Apollo.MutationResult<AdminUpdateUserMutation>;
export type AdminUpdateUserMutationOptions = Apollo.BaseMutationOptions<AdminUpdateUserMutation, AdminUpdateUserMutationVariables>;
export const GetDisplayUserDocument = gql`
    query GetDisplayUser($id: ID!) {
  getDisplayUser(id: $id) {
    firstName
    lastName
    avatarUrl
    businessRole
  }
}
    `;

/**
 * __useGetDisplayUserQuery__
 *
 * To run a query within a React component, call `useGetDisplayUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisplayUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisplayUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDisplayUserQuery(baseOptions: Apollo.QueryHookOptions<GetDisplayUserQuery, GetDisplayUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDisplayUserQuery, GetDisplayUserQueryVariables>(GetDisplayUserDocument, options);
      }
export function useGetDisplayUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDisplayUserQuery, GetDisplayUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDisplayUserQuery, GetDisplayUserQueryVariables>(GetDisplayUserDocument, options);
        }
export type GetDisplayUserQueryHookResult = ReturnType<typeof useGetDisplayUserQuery>;
export type GetDisplayUserLazyQueryHookResult = ReturnType<typeof useGetDisplayUserLazyQuery>;
export type GetDisplayUserQueryResult = Apollo.QueryResult<GetDisplayUserQuery, GetDisplayUserQueryVariables>;
export const GetDisplayUsersByUserIdsDocument = gql`
    query GetDisplayUsersByUserIds($ids: [ID!]!) {
  getDisplayUsersByUserIds(ids: $ids) {
    firstName
    lastName
    avatarUrl
    businessRole
  }
}
    `;

/**
 * __useGetDisplayUsersByUserIdsQuery__
 *
 * To run a query within a React component, call `useGetDisplayUsersByUserIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisplayUsersByUserIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisplayUsersByUserIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetDisplayUsersByUserIdsQuery(baseOptions: Apollo.QueryHookOptions<GetDisplayUsersByUserIdsQuery, GetDisplayUsersByUserIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDisplayUsersByUserIdsQuery, GetDisplayUsersByUserIdsQueryVariables>(GetDisplayUsersByUserIdsDocument, options);
      }
export function useGetDisplayUsersByUserIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDisplayUsersByUserIdsQuery, GetDisplayUsersByUserIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDisplayUsersByUserIdsQuery, GetDisplayUsersByUserIdsQueryVariables>(GetDisplayUsersByUserIdsDocument, options);
        }
export type GetDisplayUsersByUserIdsQueryHookResult = ReturnType<typeof useGetDisplayUsersByUserIdsQuery>;
export type GetDisplayUsersByUserIdsLazyQueryHookResult = ReturnType<typeof useGetDisplayUsersByUserIdsLazyQuery>;
export type GetDisplayUsersByUserIdsQueryResult = Apollo.QueryResult<GetDisplayUsersByUserIdsQuery, GetDisplayUsersByUserIdsQueryVariables>;
export const GetUsersDocument = gql`
    query GetUsers {
  getUsers {
    avatarUrl
    id
    firstName
    lastName
    phone
    email
    status
    businessRole
    securityRoles
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetUsersByUserIdsDocument = gql`
    query GetUsersByUserIds($ids: [ID!]!) {
  getUsersByUserIds(ids: $ids) {
    id
    email
    status
    firstName
    lastName
    avatarUrl
    phone
    businessRole
    securityRoles
  }
}
    `;

/**
 * __useGetUsersByUserIdsQuery__
 *
 * To run a query within a React component, call `useGetUsersByUserIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersByUserIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersByUserIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetUsersByUserIdsQuery(baseOptions: Apollo.QueryHookOptions<GetUsersByUserIdsQuery, GetUsersByUserIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersByUserIdsQuery, GetUsersByUserIdsQueryVariables>(GetUsersByUserIdsDocument, options);
      }
export function useGetUsersByUserIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersByUserIdsQuery, GetUsersByUserIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersByUserIdsQuery, GetUsersByUserIdsQueryVariables>(GetUsersByUserIdsDocument, options);
        }
export type GetUsersByUserIdsQueryHookResult = ReturnType<typeof useGetUsersByUserIdsQuery>;
export type GetUsersByUserIdsLazyQueryHookResult = ReturnType<typeof useGetUsersByUserIdsLazyQuery>;
export type GetUsersByUserIdsQueryResult = Apollo.QueryResult<GetUsersByUserIdsQuery, GetUsersByUserIdsQueryVariables>;
export const InviteUserDocument = gql`
    mutation InviteUser($email: String!, $firstName: String!, $securityRoles: [SecurityRole!]!) {
  inviteUser(email: $email, firstName: $firstName, securityRoles: $securityRoles)
}
    `;
export type InviteUserMutationFn = Apollo.MutationFunction<InviteUserMutation, InviteUserMutationVariables>;

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      securityRoles: // value for 'securityRoles'
 *   },
 * });
 */
export function useInviteUserMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserMutation, InviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, options);
      }
export type InviteUserMutationHookResult = ReturnType<typeof useInviteUserMutation>;
export type InviteUserMutationResult = Apollo.MutationResult<InviteUserMutation>;
export type InviteUserMutationOptions = Apollo.BaseMutationOptions<InviteUserMutation, InviteUserMutationVariables>;
export const LoadCurrentUserDocument = gql`
    query LoadCurrentUser {
  currentUser {
    id
    avatarUrl
    firstName
    lastName
    phone
    email
    status
    businessRole
    securityRoles
    isTheoremAdmin
  }
}
    `;

/**
 * __useLoadCurrentUserQuery__
 *
 * To run a query within a React component, call `useLoadCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoadCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<LoadCurrentUserQuery, LoadCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadCurrentUserQuery, LoadCurrentUserQueryVariables>(LoadCurrentUserDocument, options);
      }
export function useLoadCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadCurrentUserQuery, LoadCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadCurrentUserQuery, LoadCurrentUserQueryVariables>(LoadCurrentUserDocument, options);
        }
export type LoadCurrentUserQueryHookResult = ReturnType<typeof useLoadCurrentUserQuery>;
export type LoadCurrentUserLazyQueryHookResult = ReturnType<typeof useLoadCurrentUserLazyQuery>;
export type LoadCurrentUserQueryResult = Apollo.QueryResult<LoadCurrentUserQuery, LoadCurrentUserQueryVariables>;
export const RemoveRoleDocument = gql`
    mutation RemoveRole($id: ID!, $role: SecurityRole!) {
  removeRole(id: $id, role: $role)
}
    `;
export type RemoveRoleMutationFn = Apollo.MutationFunction<RemoveRoleMutation, RemoveRoleMutationVariables>;

/**
 * __useRemoveRoleMutation__
 *
 * To run a mutation, you first call `useRemoveRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRoleMutation, { data, loading, error }] = useRemoveRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useRemoveRoleMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRoleMutation, RemoveRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRoleMutation, RemoveRoleMutationVariables>(RemoveRoleDocument, options);
      }
export type RemoveRoleMutationHookResult = ReturnType<typeof useRemoveRoleMutation>;
export type RemoveRoleMutationResult = Apollo.MutationResult<RemoveRoleMutation>;
export type RemoveRoleMutationOptions = Apollo.BaseMutationOptions<RemoveRoleMutation, RemoveRoleMutationVariables>;
export const ResendInviteLinkDocument = gql`
    mutation ResendInviteLink($email: String!, $id: ID!) {
  resendInviteLink(email: $email, id: $id)
}
    `;
export type ResendInviteLinkMutationFn = Apollo.MutationFunction<ResendInviteLinkMutation, ResendInviteLinkMutationVariables>;

/**
 * __useResendInviteLinkMutation__
 *
 * To run a mutation, you first call `useResendInviteLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInviteLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInviteLinkMutation, { data, loading, error }] = useResendInviteLinkMutation({
 *   variables: {
 *      email: // value for 'email'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendInviteLinkMutation(baseOptions?: Apollo.MutationHookOptions<ResendInviteLinkMutation, ResendInviteLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInviteLinkMutation, ResendInviteLinkMutationVariables>(ResendInviteLinkDocument, options);
      }
export type ResendInviteLinkMutationHookResult = ReturnType<typeof useResendInviteLinkMutation>;
export type ResendInviteLinkMutationResult = Apollo.MutationResult<ResendInviteLinkMutation>;
export type ResendInviteLinkMutationOptions = Apollo.BaseMutationOptions<ResendInviteLinkMutation, ResendInviteLinkMutationVariables>;
export const ResendTheoremAdminInviteLinkDocument = gql`
    mutation ResendTheoremAdminInviteLink($email: String!, $id: ID!) {
  resendTheoremAdminInviteLink(email: $email, id: $id)
}
    `;
export type ResendTheoremAdminInviteLinkMutationFn = Apollo.MutationFunction<ResendTheoremAdminInviteLinkMutation, ResendTheoremAdminInviteLinkMutationVariables>;

/**
 * __useResendTheoremAdminInviteLinkMutation__
 *
 * To run a mutation, you first call `useResendTheoremAdminInviteLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendTheoremAdminInviteLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendTheoremAdminInviteLinkMutation, { data, loading, error }] = useResendTheoremAdminInviteLinkMutation({
 *   variables: {
 *      email: // value for 'email'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendTheoremAdminInviteLinkMutation(baseOptions?: Apollo.MutationHookOptions<ResendTheoremAdminInviteLinkMutation, ResendTheoremAdminInviteLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendTheoremAdminInviteLinkMutation, ResendTheoremAdminInviteLinkMutationVariables>(ResendTheoremAdminInviteLinkDocument, options);
      }
export type ResendTheoremAdminInviteLinkMutationHookResult = ReturnType<typeof useResendTheoremAdminInviteLinkMutation>;
export type ResendTheoremAdminInviteLinkMutationResult = Apollo.MutationResult<ResendTheoremAdminInviteLinkMutation>;
export type ResendTheoremAdminInviteLinkMutationOptions = Apollo.BaseMutationOptions<ResendTheoremAdminInviteLinkMutation, ResendTheoremAdminInviteLinkMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($userInfo: UpdateUserInput!) {
  updateUser(userInfo: $userInfo)
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      userInfo: // value for 'userInfo'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;